export const Categoryendpoint = {
  addCategory: `/admin/createCategory`,
  editCategory: `/admin/editCategory/`,
  addSubCategory: `/admin/create-sub-Category`,
  editSubCategory: `/admin/editSubCategory/`,
  getCategoryDetails: `/admin/getCategory`,
  deleteCategory: `/admin/deleteCategory/`,
  deleteSubCategory: `/admin/deleteSubCategory/`,
  
  // deleteSelectedCategory: `/admin/category/delete-category/`,
};
